'use client';

import { FC, useMemo, useContext } from 'react';
import { ClientDashboardMobileSegmentsProps } from './ClientDashboardMobileSegments.types';
import styles from './ClientDashboardMobileSegments.module.css';
import { SegmentedControl } from '@/_components';
import { useParams, usePathname, useRouter } from 'next/navigation';
import { UserContext } from '@/_contexts/UserProvider';
import { UserPreviewContext } from '@/_contexts/admin/UserPreviewProvider';

export const ClientDashboardMobileSegments: FC<
  ClientDashboardMobileSegmentsProps
> = () => {
  const { selectedCompanyHash } = useContext(UserContext);
  const { previewUserCompanyHash } = useContext(UserPreviewContext);
  const { push } = useRouter();
  const pathname: string = usePathname();

  const { previewUserId } = useParams();

  const baseUrl: string = useMemo(
    () => (!!previewUserId ? `/preview/user/${previewUserId}/` : '/'),
    [previewUserId],
  );

  const hash: string | undefined | null = useMemo(
    () => (!!previewUserId ? previewUserCompanyHash : selectedCompanyHash),
    [previewUserId, previewUserCompanyHash, selectedCompanyHash],
  );

  const onDashboard = () => push(baseUrl);
  const onDocuments = () => push(`${baseUrl}documents/${hash}`);

  return (
    <div className={styles.slientDashboardMobileSegments}>
      <SegmentedControl isFullWidth={true}>
        <SegmentedControl.Item
          title="Dashboard"
          onClick={onDashboard}
          isActive={`${pathname}/` === baseUrl}
        />
        <SegmentedControl.Item
          title="Documents"
          onClick={onDocuments}
          isActive={pathname.startsWith(`${baseUrl}documents`)}
        />
      </SegmentedControl>
    </div>
  );
};
